import { type CacheableEntity } from '@amzn/bf-gql'
import { createPersistedOptimisticOverlay } from '@/util/persistedOptimisticOverlay'

export type AlbumLikeState = 'LIKE' | 'DISLIKE' | 'NEUTRAL'

type AlbumLikeEntity = CacheableEntity & {
    readonly likesContext: { readonly state: AlbumLikeState }
}

// Leaf (see persistedOptimisticOverlay) so the boot-eager reapply doesn't drag
// albumLikeService's mutation + toggle machinery onto the entry chunk.
export const albumLikeOverlay = createPersistedOptimisticOverlay<AlbumLikeState>({
    persistenceKey: 'overlay:albumLike',
    validateValue: (v): v is AlbumLikeState => v === 'LIKE' || v === 'DISLIKE' || v === 'NEUTRAL',
    buildEntity: (albumId, state): AlbumLikeEntity => ({
        __typename: 'Album',
        id: albumId,
        likesContext: { state },
    }),
})

/** Re-arm the normalized cache from persisted album likes on boot. */
export const reapplyPersistedAlbumLikes = albumLikeOverlay.reapplyPersisted
